import React from "react";
import Api from "../../services/ServiceApi";

import OperatorNameDropdown from "../Dropdown_Monitor/OperatorNameDropdown";
import TableApproveStoptime from "../../components/Table_Monitor/Table_Approve_StopTime";
// import TableApproveExclusion from "../../components/Table_Monitor/Table_Approve_Exclusion";
import TableApproveAlarmClear from "../../components/Table_Monitor/Table_Approve_AlarmClear";
import TableApproveCheckCustomer from "../../components/Table_Monitor/Table_Approve_CheckCustomer";
import TableApproveInService from "../../components/Table_Monitor/Table_Approve_InService";

export default function Dashboard({
  title,
  lastDashboardUpdate,
  configComponent,
  CompanyId,
  OperatorId,
  ProjectId,
  masterLang,
  factUpdate,
  view_mode,
}) {
  const [operatorList, setoperatorList] = React.useState([]);
  const [selectOperation, setselectOperation] = React.useState([null]);
  React.useEffect(() => {
    let fetchSuccess = false;
    const fetchData = () => {
      Api.post("monitor/getmasteroperationname", {
        company_id: CompanyId,
        operator_id: OperatorId,
        project_id: ProjectId,
      }).then((res) => {
        const { result, data } = res.data;
        if (result?.code === "P") {
          setoperatorList([
            { value: null, label: "ทั้งหมด" },
            ...data.map((item) => ({
              value: item.operation_name_name,
              label: item.operation_name_name,
            })),
          ]);
        }
      });
    };

    if (!fetchSuccess) {
      fetchData();
    }
    return () => {
      fetchSuccess = true;
    };
  }, []);
  const handleChangeOperationName = (item) => {
    if (item?.length > 0) {
      if (item[item.length - 1] !== null) {
        setselectOperation(item.filter((s) => s !== null));
      } else {
        setselectOperation([null]);
      }
    } else {
      setselectOperation([null]);
    }
  };
  return (
    <>
      <div className="wrapper-header">
        <div className="container-fluid">
          <div className="row job-header">
            <div className="col col-12 col-md-6">
              <div className="d-flex align-content-center flex-wrap mr-auto">
                <img
                  src={Api.absoluteUrl("/icon/job_assignment.svg")}
                  alt={title}
                  title={title}
                />
                <h2>{title}</h2>
              </div>
            </div>
            <div className="col col-12 col-md-6">
              <div className="d-flex align-items-start align-items-md-end flex-column">
                <div className="d-flex flex-wrap pt-2">
                  <h4 className="dashboard-time">
                    {`Latest Update`} <span>: {lastDashboardUpdate}</span>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wrapper-body">
        <div className="container-fluid">
          <div className="align-content-md-start flex-wrap w-100">
            <div className="row mb-3 dashboard-wrapper-search-list">
              <div className="col col-12 col-lg-6">
                <div className="row">
                  <span className="col col-4 col-form-label">
                    Operator name
                  </span>
                  <span className="col col-8 col-form-input">
                    <OperatorNameDropdown
                      optionList={operatorList}
                      defaultValue={selectOperation}
                      onChange={handleChangeOperationName}
                    />
                  </span>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col col-12 col-lg-6">
                {configComponent?.table_stoptime.visible ? (
                  <TableApproveStoptime
                    title={"New Request Stop Time"}
                    companyId={CompanyId}
                    operatorId={OperatorId}
                    projectId={ProjectId}
                    masterLang={masterLang}
                    factUpdate={factUpdate}
                    searchCriteria={{ operationName: selectOperation }}
                    enableController={view_mode === "monitor" ? false : true}
                  />
                ) : null}
              </div>
              <div class="col col-12 col-lg-6">
                {configComponent?.table_request_inservice.visible ? (
                  <TableApproveInService
                    title={"New Request In Service"}
                    companyId={CompanyId}
                    operatorId={OperatorId}
                    projectId={ProjectId}
                    masterLang={masterLang}
                    factUpdate={factUpdate}
                    searchCriteria={{ operationName: selectOperation }}
                    enableController={view_mode === "monitor" ? false : true}
                  />
                ) : null}
              </div>
            </div>

            <div className="row">
              <div class="col col-12 col-lg-6">
                {configComponent?.table_customer_clear.visible ? (
                  <TableApproveCheckCustomer
                    title={"New Request Check Customer (Access)"}
                    companyId={CompanyId}
                    operatorId={OperatorId}
                    projectId={ProjectId}
                    masterLang={masterLang}
                    factUpdate={factUpdate}
                    searchCriteria={{ operationName: selectOperation }}
                    enableController={view_mode === "monitor" ? false : true}
                  />
                ) : null}
              </div>
              <div class="col col-12 col-lg-6">
                {configComponent?.table_alarm_clear.visible ? (
                  <TableApproveAlarmClear
                    title={"New Request Check Alarm (Network)"}
                    companyId={CompanyId}
                    operatorId={OperatorId}
                    projectId={ProjectId}
                    masterLang={masterLang}
                    factUpdate={factUpdate}
                    searchCriteria={{ operationName: selectOperation }}
                    enableController={view_mode === "monitor" ? false : true}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
